import fetchJSONData from 'app/util/fetchJSONData'

const CACHE = {}

/**
 * Load an abi JSON asset, persists loaded
 * API's into cache
 *
 * @param {string} url - the url to load
 * @returns {object} the abit data
 */
const loadAbi = async url => {
  if (CACHE[url]) {
    // Already have the ABI in CACHE, return it
    return CACHE[url]
  }

  try {
    const { data, success } = await fetchJSONData(url)

    if (!success) {
      throw new Error('Failed to fetch ABI')
    }

    CACHE[url] = data

    return data
  } catch (error) {
    console.error('Failed to load ABI:', error)

    throw error
  }
}

// export
export default loadAbi
